(function () {
  function markSoldOutProducts() {
    document.querySelectorAll('.boost-sd__product-item').forEach(function (productItem) {
      var soldOutBadge = productItem.querySelector('.boost-sd__product-label--soldout');

      if (soldOutBadge) {
        productItem.classList.add('product-sold-out');
      } else {
        productItem.classList.remove('product-sold-out');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', markSoldOutProducts);
  window.addEventListener('load', markSoldOutProducts);

  var observer = new MutationObserver(markSoldOutProducts);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setInterval(markSoldOutProducts, 1000);
})();